import { useParams, useSearchParams } from "react-router-dom";
import Hero from "../events/components/Hero";
import NavbarCustomer from "../../../components/NavbarCustomer";
import Listing from "../../home/listing/Listing";
import ExploreCities from "./ExploreCities";
import { Link } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import { useEffect, useState } from "react";

const decodeSlug = (slug) => {
	if (!slug) return "";
	return slug
		.replace(/-/g, " ") // replace hyphens with spaces
		.replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
};

const City = ({ filters, setFilters }) => {
	console.log("FILTER==========", filters);
	const [searchParams] = useSearchParams();
	const { city: citySlug } = useParams();
	const [areaCount, setAreaCount] = useState(null);
	const city = decodeSlug(citySlug);
	const count = localStorage.getItem("cityTotalCount");
	const breadcrumbPath = [
		{ name: "Home", to: "/" },
		{ name: city, to: `/city/${citySlug}` },
	];

	useEffect(() => {
		if (searchParams.get("areaCount")) {
			setAreaCount(JSON.parse(searchParams.get("areaCount")));
		}
		setFilters((prev) => ({ ...prev, city }));
	}, [city]);

	console.log("AREA COUNT:", areaCount);

	return (
		<div>
			<NavbarCustomer filters={filters} setFilters={setFilters} />
			<div className="text-[#717171] flex items-center my-4 md:mx-8 mx-1 gap-2">
				<Link to="/">Home</Link>
				<RiArrowRightSLine />
				<p className="text-dark">{city}</p>
			</div>
			<Hero
				filters={filters}
				setFilters={setFilters}
				eventTypeName={""}
				cityName={city}
				cityTotalCount={count}
			/>
			<ExploreCities city={city} filters={filters} setFilters={setFilters} />
			{/* <div className="min-h-[50px]"></div> */}
			<h2 className="md:px-8 px-4 text-[#222222] md:text-[32px] text-[18px] font-semibold mb-0">
				Search results for all venues in {city}
			</h2>
			<Listing
				filters={filters}
				setFilters={setFilters}
				showNav={false}
				areaCount={areaCount}
				breadcrumbPath={breadcrumbPath}
			/>
		</div>
	);
};

export default City;
